import {HiBadgeCheck} from 'react-icons/hi'
import {GoPrimitiveDot} from 'react-icons/go'
import {MdLockOpen} from 'react-icons/md'
import {AiOutlineClose} from 'react-icons/ai'
import {BsThreeDotsVertical} from 'react-icons/bs'
import {ImArrowUp, ImArrowDown} from 'react-icons/im'
import Coins from '../sondaria-components/Coins'
import Comments from './Comments'
import { useState } from 'react'


const Feed = () => {

    const [comments, setcomments] = useState(false)
    return (
        <div className="feed-card">
            <div className="feed-notice-area">
                <div className="feed-reacter-dps">
                    <div className="feed-react-dp1"></div>
                    <div className="feed-react-dp2"></div>
                    <div className="feed-react-dp3"></div>
                    <div className="feed-react-dp4"></div>
                </div>
                <div className="feed-reacter-main">Pseudo_1234</div>
              et <div className="feed-reacter-main">4</div> autres ont répondu à ce sondage.
            </div>
            <div className="feed-main">
                <div className="feed-header">
                    <div className="feeds-profile-pic"></div>
                    <div className="feed-profile-details">
                        <div className="feed-profile-details-handle">
                            <p>Pseudo_1234</p>
                            <HiBadgeCheck className="feed-badge"/>
                        </div>
                        <div className="feed-profile-details-time">4 min</div>
                    </div>
                    <div className="feed-profile-status">
                        <GoPrimitiveDot/>
                        <p>S'abonner</p>
                    </div>
                    <BsThreeDotsVertical className="feed-footer-icon"/>
                </div>
                <div className="feed-body">
                    <div className="feed-notice">
                    <div className="feed-notice-bar">
                        <div className="feed-notice-icon">
                            <MdLockOpen/>
                        </div>
                        <p>Ce sondage est réservé aux femmes.</p>
                        <AiOutlineClose/>
                    </div>
                    </div>
                    <div className="feed-cat-points">
                        <button>BUSINESS</button>
                        <Coins/>
                    </div>
                    <p className="feed-title">Titre du sondage</p>
                    <div className="feed-caption">
                    Iam virtutem ex consuetudine vitae sermonisque nostri interpretemur nec eam, ut quidam docti, verborum magnificentia metiamur virosque bonos eos, qui habentur, numeremus.
                    </div>
                    <div className="feed-photos">
                        <div className="feed-photo1"></div>
                    </div>
                </div>
                <div className="feed-footer">
                    <div className="feed-footer-reactions">
                        <div className="feed-votes">
                            <button className="feed-vote">
                            <ImArrowUp/>
                            </button>
                            <p className="vote-count-num">52</p>
                            <button className="feed-vote">
                            <ImArrowDown/>
                            </button>
                        </div>
                        <div className="feed-comments" onClick={()=>setcomments(!comments)}>
                            7 commentaries
                        </div>
                    </div>
                    {comments ? <Comments/> : null}
                </div>
            </div>
        </div>
    )
}

export default Feed
